<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.305 29.334">
         <path d="M14.652 0A14.615 14.615 0 004.314 4.256C1.536 7.006.004 10.659 0 14.53c0 2.344.616 4.708 1.785 6.865L.04 29.334l8.024-1.824a14.7 14.7 0 006.583 1.564h.006c3.892 0 7.563-1.514 10.336-4.258 2.782-2.752 4.315-6.4 4.317-10.273.001-3.848-1.537-7.5-4.33-10.283A14.536 14.536 0 0014.652 0zm-.002 2.29a12.269 12.269 0 018.71 3.59c2.358 2.352 3.656 5.428 3.656 8.661 0 6.75-5.549 12.242-12.364 12.242h-.006c-2.053 0-4.087-.515-5.882-1.49l-.38-.207L3.052 26.3l1.158-5.266-.223-.387c-1.11-1.914-1.697-4.029-1.697-6.113C2.293 7.785 7.838 2.29 14.65 2.29zm-4.627 5.839a1.23 1.23 0 00-.894.416c-.307.335-1.174 1.143-1.174 2.787 0 1.643 1.202 3.231 1.37 3.455.167.223 2.317 3.702 5.724 5.041 2.831 1.113 3.408.892 4.023.836.614-.056 1.983-.808 2.262-1.588.28-.78.28-1.448.195-1.588-.084-.138-.308-.222-.642-.388-.335-.168-1.978-.99-2.285-1.102-.308-.11-.53-.167-.754.168-.224.333-.883 1.105-1.078 1.328-.196.223-.392.25-.727.084-.335-.168-1.403-.527-2.684-1.664-.996-.885-1.687-2.015-1.882-2.35-.196-.334-.022-.513.146-.68.15-.15.354-.355.522-.55.167-.195.216-.334.328-.557.111-.222.054-.419-.03-.586-.084-.166-.727-1.817-1.025-2.478h.002c-.251-.556-.517-.575-.756-.584z" />
    </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
